import { Outlet } from "react-router-dom";

const MainBids = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainBids;